import { useEffect, useRef, useState } from "react";

const DEFAULT_OPTIONS = {
  threshold: 0.12,
  rootMargin: "0px 0px -4% 0px",
};

/**
 * Fires once when the observed element enters the viewport.
 */
export function useInViewOnce(options = {}) {
  const ref = useRef(null);
  const [isInView, setIsInView] = useState(false);
  const merged = { ...DEFAULT_OPTIONS, ...options };

  useEffect(() => {
    if (isInView) return;
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      merged
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [isInView, merged.threshold, merged.rootMargin]);

  return [ref, isInView];
}
